module.exports = __webpack_public_path__ + "img/nothingRed.ded0e343.png";